import React from 'react';

import ManagedFormGroup from 'components/form/managed_input/form_group';
import { classFlagOptions } from '../helpers';

import type { FormState } from '../types';

interface Props {
  customField: FormState;
  onChange: (changes: Partial<FormState>) => void;
}

export default function CustomFieldFormClasses({ customField, onChange }: Props) {
  return (
    <ManagedFormGroup
      checkboxClassName="my-0 mr-5"
      inputClassName="d-flex"
      label="Record Types"
      options={classFlagOptions}
      required
      type="checkboxGroup"
      value={customField.classFlags}
      onValueChange={classFlags => onChange({ classFlags })}
    />
  );
}
